module.exports = __webpack_public_path__ + "login-background-md.png";